export default __webpack_public_path__ + "static/media/mantle002.cbd8ff55.jpeg";